class L.Draw.BetterCircle extends L.Draw.Circle

    _getRadiusText: () ->
        if @options.units? and @options.units is 'english'
            return (@_shape.getRadius() * 3.28084).toFixed(1) + ' ft'

        return @_shape.getRadius().toFixed(1) + ' m'


    _onMouseMove: (e) =>
        @_tooltip.updatePosition e.latlng

        if (@_isDrawing)
            @_drawShape(e.latlng)

            # Get the new radius (rouded to 1 dp)
            radius = @_getRadiusText()

            @_tooltip.updateContent
                text: if @_isCurrentlyTwoClickDrawing then 'Click again to finish drawing' else 'Release mouse to finish drawing.'
                subtext: 'Radius: ' + radius

    _hasAncestor: (el, cls) =>
        # iterate through parent elements and try to find the one we want
        while not el.classList.contains(cls)
            # do nothing
            el = el.parentElement

            if not el
                break

        return el

    _onMouseUp: (e) ->
        if not @_shape and not @_isCurrentlyTwoClickDrawing
            @_isCurrentlyTwoClickDrawing = true
            # L.Draw.SimpleShape.prototype._onMouseUp.call(this)
            return

        if @_isCurrentlyTwoClickDrawing and not @_hasAncestor(e.target, 'leaflet-map-pane')
            # return doing nothing
            return

        if @_shape
            @_fireCreatedEvent()

            @disable()

            if @options.repeatMode
                @enable()

    _onMouseDown: (e) ->
        @_isDrawing = true
        if not @_isCurrentlyTwoClickDrawing
            @_startLatLng = e.latlng

        L.DomEvent
            .on(document, 'mouseup', @_onMouseUp, this)
            .on(document, 'touchend', @_onMouseUp, this)
            .preventDefault(e.originalEvent)
